import React, { useState, useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServicesSection = () => {
  const [activeService, setActiveService] = useState(0);
  const [visibleCards, setVisibleCards] = useState(new Set());
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const cardRefs = useRef([]);

  const services = [
    {
      id: 'tango-wachs',
      title: 'Tango Wachs',
      subtitle: 'Premium Wachsbehandlung',
      description: 'Hochwertige Wachsbehandlung für optimalen Glanz und Schutz. Verleiht Ihrem Fahrzeug einen tiefen, warmen Glanz.',
      features: ['Tiefenglanz', 'Wasserschutz', 'UV-Schutz', 'Langanhaltend'],
      price: 'ab 30€',
      duration: '2-3 Stunden',
      image: '/assets/images/Generated Image October 04, 2025 - 12_39AM.png',
      icon: 'Sparkles'
    },
    {
      id: 'aussenhandwaesche',
      title: 'Außenhandwäsche',
      subtitle: 'Gründliche Außenreinigung',
      description: 'Professionelle Handwäsche des Fahrzeugaußenbereichs mit hochwertigen Reinigungsmitteln und schonenden Techniken.',
      features: ['Handwäsche', 'Felgenreinigung', 'Scheibenreinigung', 'Trocknung'],
      price: 'ab 20€',
      duration: '1-2 Stunden',
      image: "/assets/images/vecteezy_a-person-washing-the-front-of-a-red-car_58142368.jpg",
      icon: 'Droplets'
    },
    {
      id: 'innen-aussen',
      title: 'Innenreinigung + Außenhandwäsche',
      subtitle: 'Komplettservice',
      description: 'Kombinierter Service aus Innenraumreinigung und Außenhandwäsche für eine umfassende Fahrzeugpflege.',
      features: ['Innenreinigung', 'Außenhandwäsche', 'Polsterreinigung', 'Geruchsbeseitigung'],
      price: 'ab 55€',
      duration: '3-4 Stunden',
      image: '/assets/images/Generated Image October 04, 2025 - 12_57AM.png',
      icon: 'Car'
    },
    {
      id: 'lederpflege',
      title: 'Lederpflege',
      subtitle: 'Leather Care',
      description: 'Professionelle Pflege und Reinigung von Lederpolstern für langanhaltende Schönheit und Schutz.',
      features: ['Lederreinigung', 'Konditionierung', 'Schutzbehandlung', 'Glanzverstärkung'],
      price: 'ab 40€',
      duration: '1-2 Stunden',
      image: "/assets/images/vecteezy_taking-care-about-brown-colored-seats-modern-black_16727981.jpg",
      icon: 'Heart'
    },
    {
      id: 'nanoversiegelung',
      title: 'Nanoversiegelung',
      subtitle: 'Premium Schutz',
      description: 'Langanhaltender Schutz vor Umwelteinflüssen mit bis zu 2 Jahren Haltbarkeit. Hydrophobe Eigenschaften sorgen für selbstreinigende Effekte.',
      features: ['2 Jahre Haltbarkeit', 'Selbstreinigender Effekt', 'UV-Schutz', 'Kratzresistenz'],
      price: 'ab 399€',
      duration: '4-6 Stunden',
      image: "/assets/images/vecteezy_wet-car-under-dark-sky_10218168.jpg",
      icon: 'Shield'
    },
    {
      id: 'keramikversiegelung',
      title: 'Keramikversiegelung',
      subtitle: 'Ultimate Protection',
      description: 'Höchste Schutzstufe mit Keramikbeschichtung für maximalen Glanz und langanhaltenden Schutz.',
      features: ['3 Jahre Haltbarkeit', 'Ultra-Glanz', 'Chemikalien-Schutz', 'Selbstreinigung'],
      price: 'ab 620€',
      duration: '6-8 Stunden',
      image: "/assets/images/vecteezy_a-man-in-an-orange-overall-is-working-on-a-car_71101018.jpeg",
      icon: 'Shield'
    },
    {
      id: 'polsterreinigung',
      title: 'Polsterreinigung',
      subtitle: 'Fabric Care',
      description: 'Spezielle Reinigung von Stoffpolstern mit professionellen Geräten und Reinigungsmitteln.',
      features: ['Tiefenreinigung', 'Fleckenentfernung', 'Geruchsbeseitigung', 'Schutzbehandlung'],
      price: 'ab 29€',
      duration: '1-2 Stunden',
      image: "/assets/images/vecteezy_a-man-cleaning-the-interior-of-a-car_71102777.jpeg",
      icon: 'Droplets'
    },
    {
      id: 'himmelreinigung',
      title: 'Himmelreinigung',
      subtitle: 'Headliner Care',
      description: 'Sorgfältige Reinigung des Fahrzeugdachhimmels mit speziellen Techniken und Reinigungsmitteln.',
      features: ['Staubentfernung', 'Fleckenbehandlung', 'Geruchsbeseitigung', 'Schutzbehandlung'],
      price: 'ab 50€',
      duration: '1 Stunde',
      image: "/assets/images/Gemini_Generated_Image_rolha5rolha5rolh.png",
      icon: 'Sun'
    },
    {
      id: 'motor-wache',
      title: 'Motor Wache',
      subtitle: 'Engine Care',
      description: 'Professionelle Reinigung und Pflege des Motorraums für optimale Leistung und Langlebigkeit.',
      features: ['Motorreinigung', 'Entfettung', 'Schutzbehandlung', 'Kabelpflege'],
      price: 'ab 39€ Keine Haftung für Folgeshäden',
      duration: '1-2 Stunden',
      image: "/assets/images/Gemini_Generated_Image_mqvszjmqvszjmqvs.png",
      icon: 'Settings'
    },
    // {
    //   id: 'innen-komplet-aussen',
    //   title: 'Innen Komplet + Außenhandwäsche',
    //   subtitle: 'Full Interior + Exterior',
    //   description: 'Umfassende Innenraumreinigung kombiniert mit Außenhandwäsche für komplette Fahrzeugpflege.',
    //   features: ['Komplette Innenreinigung', 'Außenhandwäsche', 'Polsterreinigung', 'Lederpflege'],
    //   price: 'ab 199€',
    //   duration: '4-5 Stunden',
    //   image: '/assets/images/Generated Image October 04, 2025 - 12_57AM.png',
    //   icon: 'Car'
    // },
    // {
    //   id: 'innen-komplet',
    //   title: 'Innen Komplet',
    //   subtitle: 'Complete Interior',
    //   description: 'Vollständige Innenraumreinigung mit allen Premium-Services für perfekte Sauberkeit.',
    //   features: ['Polsterreinigung', 'Lederpflege', 'Himmelreinigung', 'Geruchsbeseitigung'],
    //   price: 'ab 149€',
    //   duration: '3-4 Stunden',
    //   image: "/assets/images/vecteezy_a-person-in-black-gloves-cleaning-the-dashboard-of-a-car_71102465.jpeg",
    //   icon: 'Armchair'
    // },
    // {
    //   id: 'polieren',
    //   title: 'Polieren',
    //   subtitle: 'Paint Polishing',
    //   description: 'Professionelle Politur des Fahrzeuglacks für maximalen Glanz und Tiefe.',
    //   features: ['Hochglanz-Politur', 'Farbtiefe', 'Kratzer-Minimierung', 'UV-Schutz'],
    //   price: 'ab 129€',
    //   duration: '2-3 Stunden',
    //   image: "/assets/images/vecteezy_car-detailing-male-mechanic-holding-car-polishing-machine_3582888.jpg",
    //   icon: 'Sparkles'
    // },
    {
      id: 'lackaufbereitung',
      title: 'Lackaufbereitung',
      subtitle: 'Paint Correction',
      description: 'Professionelle Aufbereitung des Fahrzeuglacks zur Entfernung von Kratzern, Hologrammen und Oxidation.',
      features: ['Kratzer-Entfernung', 'Polieren', 'Farbtiefe', 'Hochglanz'],
      price: 'ab 139€',
      duration: '4-6 Stunden',
      image: "/assets/images/vecteezy_car-being-polished_2117775.jpg",
      icon: 'Wrench'
    },
    {
      id: 'komplettaufbereitung',
      title: 'Komplettaufbereitung',
      subtitle: 'Full Service',
      description: 'Umfassende Aufbereitung von Innen- und Außenbereich mit allen Premium-Services für perfekte Ergebnisse.',
      features: ['Innenreinigung', 'Lackaufbereitung', 'NANO-Versiegelung', 'Polsterreinigung'],
      price: 'ab 199€',
      duration: '6-8 Stunden',
      image: '/assets/images/Generated Image October 04, 2025 - 12_57AM.png',
      icon: 'Star'
    },
    {
      id: 'innenreinigung',
      title: 'Innenreinigung',
      subtitle: 'Interior-Detailing',
      description: 'Gründliche Reinigung des Fahrzeuginnenraums mit speziellen Reinigungsmitteln für alle Materialien.',
      features: ['Polsterreinigung', 'Lederpflege', 'Himmelreinigung', 'Geruchsbeseitigung'],
      price: 'ab 38€',
      duration: '2-3 Stunden',
      image: "/assets/images/vecteezy_close-up-hand-interior-car-cleaning_35034131.jpg",
      icon: 'Armchair'
    }
  ];

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardIndex = parseInt(entry.target.dataset.index);
            setVisibleCards(prev => new Set([...prev, cardIndex]));
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '100px 0px 100px 0px'
      }
    );

    cardRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const openServiceModal = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedService(null);
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerHeight = 80;
      const elementPosition = element?.getBoundingClientRect()?.top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Icon name="Star" size={16} />
            <span className="text-sm font-medium">Premium Services</span>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground mb-6">
            Unsere
            <span className="block text-primary">Leistungen</span>
          </h2>
          <p className="text-base text-muted-foreground max-w-3xl mx-auto">
            Von der NANO-Versiegelung bis zur Komplettreinigung – 
            wir bieten alle Services für die perfekte Autopflege.
          </p>
        </div>

        {/* Services Grid Overview */}
        <div className="mb-16">
          <h3 className="text-lg font-bold text-center text-foreground mb-8">
            Alle Services im Überblick
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {services?.map((service, index) => {
              const isVisible = visibleCards.has(index);
              return (
                <div
                  key={service?.id}
                  ref={(el) => (cardRefs.current[index] = el)}
                  data-index={index}
                  className={`group bg-white rounded-xl border border-border hover:border-primary/50 hover:shadow-lg transition-all duration-500 overflow-hidden cursor-pointer transform ${
                    isVisible 
                      ? 'opacity-100 translate-y-0 scale-100' 
                      : 'opacity-0 translate-y-6 scale-98'
                  }`}
                  style={{
                    transitionDelay: `${index * 50}ms`
                  }}
                  onClick={() => {
                    setActiveService(index);
                    openServiceModal(service);
                  }}
                >
                <div className="relative h-48">
                  <Image
                    src={service?.image}
                    alt={service?.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute top-4 right-4">
                    <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                      <Icon name={service?.icon} size={20} color="white" />
                    </div>
                  </div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <h4 className="text-sm font-bold text-white mb-1">{service?.title}</h4>
                    <p className="text-white/90 text-xs">{service?.subtitle}</p>
                  </div>
                </div>
                
                <div className="p-4">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-xl font-bold text-primary">{service?.price}</span>
                    <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                      <Icon name="Clock" size={16} />
                      <span>{service?.duration}</span>
                    </div>
                  </div>
                  
                  <p className="text-xs text-muted-foreground mb-4 line-clamp-3">{service?.description}</p>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                      <Icon name="CheckCircle" size={16} />
                      <span>{service?.features?.length} Merkmale</span>
                    </div>
                    <button
                      className="text-xs font-medium text-primary group-hover:text-primary/80 transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        openServiceModal(service);
                      }}
                    >
                      Details →
                    </button>
                  </div>
                </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Service Grid */}
        <div className="grid lg:grid-cols-5 gap-4 mb-12">
          {/* Service Cards */}
          <div className="lg:col-span-2 space-y-4 max-h-[400px] lg:max-h-[600px] overflow-y-auto pr-2">
            {services?.map((service, index) => (
              <div
                key={service?.id}
                className={`p-4 rounded-xl border-2 cursor-pointer transition-all duration-300 ${
                  activeService === index
                    ? 'border-primary bg-primary/5 shadow-card'
                    : 'border-border bg-white hover:border-primary/50 hover:shadow-input'
                }`}
                onClick={() => setActiveService(index)}
              >
                <div className="flex items-start space-x-6">
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                    activeService === index ? 'bg-primary text-white' : 'bg-muted text-muted-foreground'
                  }`}>
                    <Icon name={service?.icon} size={20} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="text-base font-bold text-foreground">{service?.title}</h3>
                      <span className="text-base font-bold text-primary ml-2">{service?.price}</span>
                    </div>
                    <p className="text-xs text-primary font-medium mb-3">{service?.subtitle}</p>
                    <p className="text-xs text-muted-foreground mb-4 line-clamp-4">{service?.description}</p>
                    <div className="flex items-center space-x-6 text-xs text-muted-foreground">
                      <div className="flex items-center space-x-2">
                        <Icon name="Clock" size={16} />
                        <span>{service?.duration}</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Icon name="CheckCircle" size={16} />
                        <span>{service?.features?.length} merkmale</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Active Service Details */}
          <div className="lg:col-span-3 lg:sticky lg:top-24">
            <div className="bg-gradient-to-br from-muted/30 to-white rounded-xl overflow-hidden shadow-card">
              <div className="relative h-48 md:h-64">
                <Image
                  src={services?.[activeService]?.image}
                  alt={services?.[activeService]?.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-lg font-bold text-white mb-1">
                    {services?.[activeService]?.title}
                  </h3>
                  <p className="text-white/90">{services?.[activeService]?.subtitle}</p>
                </div>
              </div>

              <div className="p-4">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <div className="text-xl font-bold text-primary mb-1">
                      {services?.[activeService]?.price}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      Dauer: {services?.[activeService]?.duration}
                    </div>
                  </div>
                  <Button
                    variant="default"
                    className="bg-primary hover:bg-primary/90"
                    onClick={scrollToContact}
                    iconName="Calendar"
                    iconPosition="left"
                  >
                    Buchen
                  </Button>
                </div>

                <div className="space-y-3">
                  <h4 className="text-xs font-semibold text-foreground">Leistungen im Detail:</h4>
                  {services?.[activeService]?.features?.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <Icon name="Check" size={16} className="text-success" />
                      <span className="text-xs text-muted-foreground">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-4 p-3 bg-primary/10 rounded-md">
                  <p className="text-sm text-primary font-medium">
                    💡 Tipp: Kombinieren Sie mehrere Services für optimale Ergebnisse und Rabatte!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Service Process */}
        <div className="bg-muted/30 rounded-xl p-4">
          <h3 className="text-lg font-bold text-center text-foreground mb-8">
            Unser 5-Schritte Prozess
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6">
            {[
              { icon: 'Calendar', title: 'Termin', desc: 'Online buchen' },
              { icon: 'Car', title: 'Annahme', desc: 'Fahrzeug übergeben' },
              { icon: 'Settings', title: 'Service', desc: 'Professionelle Pflege' },
              { icon: 'CheckCircle', title: 'Qualität', desc: 'Endkontrolle' },
              { icon: 'Key', title: 'Übergabe', desc: 'Fahrzeug abholen' }
            ]?.map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
                  <Icon name={step?.icon} size={18} color="white" />
                </div>
                <h4 className="text-xs font-semibold text-foreground mb-2">{step?.title}</h4>
                <p className="text-xs text-muted-foreground">{step?.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Service Details Modal */}
      {isModalOpen && selectedService && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-2 md:p-4">
            <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] md:max-h-[80vh] overflow-y-auto relative">
            {/* Modal Header */}
            <div className="relative">
              <div className="relative h-64">
                <Image
                  src={selectedService?.image}
                  alt={selectedService?.title}
                  className="w-full h-full object-cover rounded-t-xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-t-xl" />
                <button
                  onClick={closeModal}
                  className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
                >
                  <Icon name="X" size={20} color="white" />
                </button>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-xl font-bold text-white mb-2">{selectedService?.title}</h3>
                  <p className="text-white/90 text-sm">{selectedService?.subtitle}</p>
                </div>
              </div>
            </div>

            {/* Modal Content */}
            <div className="p-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 space-y-4 sm:space-y-0">
                <div>
                  <div className="text-2xl font-bold text-primary mb-2">{selectedService?.price}</div>
                  <div className="text-xs text-muted-foreground">
                    Dauer: {selectedService?.duration}
                  </div>
                </div>
                <Button
                  variant="default"
                  className="bg-primary hover:bg-primary/90 w-full sm:w-auto"
                  onClick={scrollToContact}
                  iconName="Calendar"
                  iconPosition="left"
                >
                  Jetzt buchen
                </Button>
              </div>

              <div className="mb-6">
                <h4 className="text-sm font-semibold text-foreground mb-4">Beschreibung</h4>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {selectedService?.description}
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-sm font-semibold text-foreground mb-4">Leistungen im Detail</h4>
                <div className="grid grid-cols-1 gap-3">
                  {selectedService?.features?.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <Icon name="Check" size={16} className="text-success flex-shrink-0" />
                      <span className="text-xs text-muted-foreground">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-primary/10 rounded-md p-3">
                <p className="text-sm text-primary font-medium">
                  💡 Tipp: Kombinieren Sie mehrere Services für optimale Ergebnisse und Rabatte!
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ServicesSection;